import type { SVGProps } from 'react';

export function SvgBackToTop(props: SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      {...props}
      fill="none"
      height="1em"
      viewBox="0 0 25 25"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12.396 24.4c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12-6.628 0-12 5.373-12 12 0 6.628 5.372 12 12 12m.468-14.963-.468-.468-.468.468-4.992 4.992.936.936 4.524-4.523 4.523 4.523.936-.936z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
